import React, { Fragment } from "react";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import WhyJoinUs1 from "./WhyJoinUs1";

const WhyJoinUs = () => {
  return (
    <Fragment>
      <PageTitle pageTitle={"Why Join Us"} pagesub={"Why Join Us"} />
      <WhyJoinUs1 />
      <Scrollbar />
    </Fragment>
  );
};
export default WhyJoinUs;
